export enum Environment {
  Production = 'production',
  QA = 'qa',
  Development = 'dev',
  Workstation = 'workstation',
}

export const Environments: Environment[] = [Environment.Workstation, Environment.Development, Environment.QA, Environment.Production]
declare global {
  interface Window {
    pcEnv: Record<string, string>
  }
}

const config = {
  api: getEnv('REACT_APP_API'),
  v3Api: getEnv('REACT_APP_V3_API'),
  renderer: getEnv('REACT_APP_RENDERER'),
  environment: getEnv('REACT_APP_ENV') as Environment,
  mapboxToken: getEnv('REACT_APP_MAPBOX_TOKEN'),
  build: getEnv('REACT_APP_UI_BUILD'),
  recaptchaKey: getEnv('REACT_APP_RECAPTCHA_KEY'),
  strictMode: process.env.REACT_APP_RUN_IN_STRICT_MODE === 'true' || getEnv('REACT_APP_UI_BUILD') === 'workstation',
  sessionKey: 'pc:admin:auth',
  filtersKey: 'pc:filters',
  languageKey: 'language',
  logLevel: 'all',
  // Triggers different Sentry logs.
  debugLogs: true,
  // Used to identify different iterations of filters so we can handle transitions
  filterVersionKey: 'pc:filters:version',
  filterVersionCurrent: '2',
  // Auth0 config
  auth0Domain: getEnv('REACT_APP_AUTH0_DOMAIN'),
  auth0ClientId: getEnv('REACT_APP_AUTH0_CLIENT_ID'),
  auth0Audience: getEnv('REACT_APP_AUTH0_AUDIENCE'),
  auth0RedirectUri: getEnv('REACT_APP_AUTH0_REDIRECT_URI'),
  auth0Scope: 'openid profile email',
  // Datadog
  datadogClientToken: getEnv('REACT_APP_DATADOG_CLIENT_TOKEN'),
  // Feature flag: show "reporting unavailable" message instead of Looker dashboards
  dashboardsDown: getOptionalEnv('REACT_APP_DASHBOARDS_DOWN', 'false') === 'true',
  powerboardLeadsEmbedURL: getOptionalEnv(
    'REACT_APP_POWERBOARD_LEADS_EMBED_URL',
    'https://powerboard.powerchord.com/embedded/public/09bb9856-b0f9-4c5d-9ced-9f84192748a9/Leads'
  ),
  powerboardLeadsEnabled: getOptionalEnv('REACT_APP_POWERBOARD_LEADS_ENABLED', 'false') === 'true',
  powerboardCallTrackingEmbedURL: getOptionalEnv(
    'REACT_APP_POWERBOARD_CALL_TRACKING_EMBED_URL',
    'https://powerboard.powerchord.com/embedded/public/33231d56-0426-4caf-ac40-20deaa01b13e'
  ),
  powerboardCallTrackingEnabled: getOptionalEnv('REACT_APP_POWERBOARD_CALL_TRACKING_ENABLED', 'false') === 'true',
}

function getEnv(envVar: string): string {
  let ret: string | undefined
  if (process.env.NODE_ENV !== 'production' && envVar === 'REACT_APP_MAPBOX_TOKEN') {
    ret = 'dummy_token'
  } else if (process.env.NODE_ENV !== 'production' && process.env[envVar]) {
    ret = process.env[envVar]
  } else if (window.pcEnv) {
    ret = window.pcEnv[envVar]
  }
  if (!ret) {
    throw new Error(`Missing environment variable: ${envVar}. Make sure you add environment variables to apps/admin/.env!`)
  }
  return ret
}

function getOptionalEnv(envVar: string, defaultValue: string): string {
  if (process.env.NODE_ENV !== 'production' && process.env[envVar]) {
    return process.env[envVar]!
  } else if (window.pcEnv && window.pcEnv[envVar]) {
    return window.pcEnv[envVar]
  }
  return defaultValue
}

export default config
